module.exports = require('./readable').PassThrough



// WEBPACK FOOTER //
// ./~/readable-stream/passthrough.js